<template>
  <v-card outlined class="rounded-lg">
    <v-img v-if="!hideImage" :src="'/static/calendarEventImages/img_planmyday_1x.jpg'" height="100px" class="mb-1">
      <v-card-title class="white--text hidden-xs-only">Veranstaltungen</v-card-title>
    </v-img>
    <v-card-title v-else class="hidden-xs-only">Veranstaltungen</v-card-title>
    <v-skeleton-loader
      v-if="$vars.loading"
      ref="skeleton"
      type="list-item-avatar-two-line"
      class="mx-auto"
    ></v-skeleton-loader>
    <v-list dense class="py-0" nav>
      <v-subheader v-if="Object.keys(veranstaltungen).length == 0" class="justify-center">
        Keine Veranstaltungen geplant.
      </v-subheader>
      <span v-for="(veranstaltung, monat) in veranstaltungen" :key="monat">
        <v-subheader class="justify-center title">{{ $filters.date(monat, "MMM") }}</v-subheader>
        <v-list-item
          @click="
            veranstaltungDialog = true;
            selectedEvent = item;
          "
          class="mx-2 pa-1 rounded-lg"
          v-for="(item, index) in veranstaltung"
          :key="index"
        >
          <v-list-item-action style="width: 60px" class="mx-0 px-2 justify-center align-start">
            <div class="text-center">
              <!-- <div class="caption">{{ $filters.date(item.vonDatum, "DD") }}</div> -->
              <div class="title font-weight-bold">{{ $filters.date(item.vonDatum, "DD.") }}</div>
              <div class="caption">{{ $filters.date(item.vonDatum, "MMM") }}</div>
            </div>
          </v-list-item-action>
          <v-divider vertical></v-divider>
          <v-list-item-content class="pl-2">
            <div class="d-flex">
              <span class="d-flex align-center mr-2">
                <v-icon small class="green--text" v-if="item.anmeldungen.includes(currentBbr)">check_circle</v-icon>
                <v-icon small class="grey--text" v-else>help</v-icon>
              </span>
              <span class="text-body-2 font-weight-medium">
                {{ item.titel }}
              </span>
            </div>
            <v-list-item-subtitle>
              <v-icon small class="pr-2 hidden-xs-only">access_time</v-icon>{{ item.vonZeit }} Uhr
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-icon small class="pr-2 hidden-xs-only">group</v-icon
              >{{ item.anmeldungen.length + item.weitereAnmeldungen.length }} Zusage<span
                v-if="item.anmeldungen.length + item.weitereAnmeldungen.length !== 1"
                >n</span
              >
            </v-list-item-subtitle>
            <v-list-item-subtitle v-if="item.kalender !== 'Ripuaria'">
              <v-icon small class="pr-2 hidden-xs-only">calendar_month</v-icon>{{ item.kalender }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action
            class="text-center"
            v-if="
              item.anmeldungBis &&
              (new Date(item.anmeldungBis).getTime() - new Date(datum).getTime()) / 1000 / 60 / 60 / 24 < 7 &&
              (new Date(item.anmeldungBis).getTime() - new Date(datum).getTime()) / 1000 / 60 / 60 / 24 > 0
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="caption"
                  ><v-icon small>alarm</v-icon><br />{{
                    (new Date(item.anmeldungBis).getTime() - new Date(datum).getTime()) / 1000 / 60 / 60 / 24
                  }}
                  Tage</span
                >
              </template>
              <span>Anmeldefrist</span>
            </v-tooltip>
          </v-list-item-action>
        </v-list-item>
      </span>
    </v-list>
    <v-card-actions class="hidden-xs-only">
      <v-spacer></v-spacer>
      <v-btn to="./veranstaltungen" text class="primary--text">Alle Veranstaltungen</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>

    <dialogVeranstaltung
      :visible.sync="veranstaltungDialog"
      :selectedEvent="selectedEvent"
      @close="veranstaltungDialog = false"
    ></dialogVeranstaltung>
  </v-card>
</template>

<script>
  export default {
    props: ["anzahl", "kalender", "hideImage"],
    data() {
      return {
        search: "",
        heute: new Date().toISOString().substr(0, 10),
        datum: new Date().toISOString().substr(0, 10),
        name: "",
        veranstaltungDialog: false,
        selectedEvent: {
          anmeldung: [],
          anmeldungen: [],
          weitereAnmeldungen: [],
        },
        showAlleAnmeldungen: false,
        showWeiterenAnmelden: false,
        showZuVeranstaltungAbmelden: false,
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      veranstaltungen() {
        if (this.$store.state.veranstaltungen.loaded === false) {
          this.$store.dispatch("veranstaltungen/loadVeranstaltungen");
        }
        let alleevents = [];
        if (this.kalender) {
          alleevents = this.$store.getters["veranstaltungen/nachsteVeranstaltungen"]
            .filter((event) => event.kalender === this.kalender)
            .slice(0, this.anzahl);
        } else {
          this.$store.getters["einstellungen/einstellung"]("kalender").forEach((kal) => {
            this.$store.getters["veranstaltungen/nachsteVeranstaltungen"]
              .filter((event) => event.kalender === kal.name)
              .slice(0, this.anzahl)
              .forEach((event) => {
                alleevents.push(event);
              });
          });
          alleevents = alleevents.sort((a, b) => {
            // Vergleiche zuerst nach 'vonDatum'
            const dateComparison = new Date(a.vonDatum) - new Date(b.vonDatum);
            // Wenn 'vonDatum' gleich ist, vergleiche nach 'vonZeit'
            if (dateComparison === 0) {
              const timeComparison = a.vonZeit.localeCompare(b.vonZeit);
              return timeComparison;
            }
            return dateComparison;
          });
          // Begrenze die Anzahl der Elemente auf 'anzahl'
          alleevents = alleevents.slice(0, this.anzahl);
        }
        const gruppierteVeranstaltungen = {};
        alleevents.forEach((event) => {
          event.farbe = "black--text";
          event.start = event.vonDatum + " " + event.vonZeit;
          event.end = event.bisDatum;
          event.name = event.titel;
          const monat =
            new Date(event.vonDatum).getFullYear() +
            "-" +
            ("0" + (new Date(event.vonDatum).getMonth() + 1)).slice(-2) +
            "-01";
          if (!gruppierteVeranstaltungen[monat]) {
            gruppierteVeranstaltungen[monat] = [];
          }
          gruppierteVeranstaltungen[monat].push(event);
        });
        return gruppierteVeranstaltungen;
      },
      userIstAngemeldet() {
        let bbr;
        this.$store.state.bbrbbr.bbrbbr.forEach((item) => {
          if (item.anmeldeID === this.$firebase.auth().currentUser.uid) {
            bbr = item.id;
          }
        });
        if (this.selectedEvent) {
          for (var i = 0; i < this.selectedEvent.anmeldung.length; i++) {
            if (this.selectedEvent.anmeldung[i].id === bbr) {
              return true;
            }
          }
        }
        return false;
      },
    },
    methods: {
      zuVeranstaltungAnmelden() {
        this.selectedEvent.anmeldungen.push(this.currentBbr);
        this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
        this.$firebase.analytics().logEvent("zuVeranstaltungAnmelden", {
          currentBbr: this.currentBbr,
          name: this.currentBbr,
        });
      },
      zuVeranstaltungAbmelden() {
        this.selectedEvent.anmeldungen.splice(this.selectedEvent.anmeldungen.indexOf(this.currentBbr), 1);
        this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
        this.$firebase.analytics().logEvent("zuVeranstaltungAbmelden", {
          currentBbr: this.currentBbr,
          name: this.currentBbr,
        });
        this.showZuVeranstaltungAbmelden = false;
      },
      weiterenAnmelden() {
        if (!this.selectedEvent.weitereAnmeldungen) {
          this.selectedEvent.weitereAnmeldungen = [];
        }
        this.selectedEvent.weitereAnmeldungen.push({
          angemeldetVon: this.currentBbr,
          name: this.name,
        });
        this.name = "";
        this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
      },
      weiterenAbmelden(item) {
        this.selectedEvent.weitereAnmeldungen.splice(this.selectedEvent.weitereAnmeldungen.indexOf(item), 1);
        this.$store.dispatch("veranstaltungen/updateVeranstaltungData", this.selectedEvent);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// veranstaltungenListe.vue?37a738ba